export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const LOGIN_WITH_API = import.meta.env.VITE_APP_AUTH_REDIRECT_PATH;
export const ADMIN = '/admin';
export const ADMIN_JOB_CREATE = `/admin/jobs/create`;
export const DATA_CERTIFICATIONS = `/datacertifications`;
export const ADMIN_DATA_CERTIFICATIONS = `${ADMIN}${DATA_CERTIFICATIONS}`;
export const SNACKPACK = '/snackpack';
export const EXECUTIONS = `/executions`;
export const EXECUTION_SUMMARY = `/executions/:jobName/:logId`;
export const EXECUTION_RULE_FAILURES = `${EXECUTION_SUMMARY}/:ruleName`;
export const CREATE_RULE = `/rules/create`;
export const JOB = `/jobs/:jobName`;
export const EDIT_JOB = `${JOB}/edit`;
export const COPY_JOB = `${JOB}/copy`;
export const EXECUTE_JOB = `${JOB}/execute`;
export const VIEW_JOB_EXECUTION_LOG = `${EXECUTE_JOB}/:executionId`;
export const CREATE_JOB = `/jobs/create`;
export const RULE = `/rules/:ruleName`;
export const EDIT_RULE = `${RULE}/edit`;
export const EXECUTE_RULE = `${RULE}/execute`;
export const VIEW_RULE_EXECUTION_LOG = `${EXECUTE_RULE}/:executionId`;
export const VARIABLE = `/variables/:variableName`;
export const EDIT_VARIABLE = `${VARIABLE}/edit`;
export const CREATE_VARIABLE = `/variables/create`;
export const ROUTE_NOT_FOUND = '/404';
export const GROUP = `/groups/:groupName`;
export const CREATE_GROUP = `/groups/create`;
export const EDIT_GROUP = `${GROUP}/edit`;
export const EDFI_CREDINTIAL_MANAGER = `/credential-manager`

export const getLinkToExecutionSummaryPage = (jobName: string, logId: string): string => `/executions/${jobName}/${logId}`;
export const getLinkToExecutionRuleFailuresPage = (jobName: string, logId: string, ruleName: string): string => `/executions/${jobName}/${logId}/${ruleName}`;

export const getLinkToJob = (jobId: string): string => `/admin/jobs/${jobId}`;
export const getLinkToCopyJob = (jobId: string): string => `/admin/jobs/${jobId}/copy`;
export const getLinkToEditJob = (jobId: string): string => `/admin/jobs/${jobId}/edit`;
export const getLinkToExecuteJob = (jobId: string): string => `/admin/jobs/${jobId}/execute`;
export const getLinkToExecuteJobLog = (jobId: string, executionId: string): string => `/admin/jobs/${jobId}/execute/${executionId};`;

export const getLinkToRule = (ruleId: string): string => `/admin/rules/${ruleId}`;
export const getLinkToEditRule = (ruleId: string): string => `/admin/rules/${ruleId}/edit`;
export const getLinkToExecuteRule = (ruleId: string): string => `/admin/rules/${ruleId}/execute`;
export const getLinkToExecuteRuleLog = (ruleId: string, executionId: string): string => `/admin/rules/${ruleId}/execute/${executionId}`;
export const getLinkToCreateRule = (): string => `/admin/rules/create`;

export const getLinkToVariable = (variableId: string): string => `/admin/variables/${variableId}`;
export const getLinkToEditVariable = (variableId: string): string => `/admin/variables/${variableId}/edit`;
export const getLinkToCreateVariable = (): string => `/admin/variables/create`;

export const getLinkToGroup = (groupId: string): string => `/admin/groups/${groupId}`;
export const getLinkToEditGroup = (groupId: string): string => `/admin/groups/${groupId}/edit`;
export const getLinkToCreateGroup = (): string => `/admin/groups/create`;
